<template>
  <div class="pop-bg custom-share">
    <div class="new-pic-preview">
      <new-good-main-picture v-if="wechatTimeLine==1" @picFinish="sharePicFinish"></new-good-main-picture>
      <newShopMainPicture v-if="wechatTimeLine==2" @picFinish="sharePicFinish"></newShopMainPicture>
      <RenewedPicture v-if="wechatTimeLine==3" @picFinish="sharePicFinish" />
      <EnterprisePicture v-if="wechatTimeLine==4" @picFinish="sharePicFinish" />
    </div>
    <div class="share-wrapper">
      <!-- <div class="title-line">您的好友通过分享购买，您将赚到不菲的佣金</div> -->
      <div class="title-line" v-if="title">{{title}}</div>
      <div class="share-list">
        <ul class="share-way-list">
          <li v-for="item of shareWayList" class="share-item" :key="item.label" @click="shareHandler(item.params)">
            <div class="icon-wrapper">
              <img :src="item.img" alt="">
            </div>
            <div class="share-name">{{item.label}}</div>
          </li>
        </ul>
        <ul class="share-way-list" @click="linkShare">
          <li class="share-item">
            <div class="icon-wrapper J_copy">
              <img src="https://statics02.ehaier.com/h5/ehaier/common/copylink_icon.png" alt="">
            </div>
            <div class="share-name">复制链接</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="cancle-btn">
      <a href="javascript:;" @click="cancel">取消</a>
    </div>
  </div>
</template>

<script>
import './custom-share.scss'
import ClipboardJS from 'clipboard';
import UplusApi from '@uplus/uplus-api'
import { checkIdentity } from '@/http/service/shop'
import { myManageinfo } from '@/http/service/mine'
import utils from '@/utils/utils'
import newGoodMainPicture from '@/components/picture-share/components/new-good-main-picture-small.vue'
import newShopMainPicture from '@/components/picture-share/components/new-shop-main-picture-small.vue'
import RenewedPicture from '@/components/picture-share/components/renewed-picture.vue'
import EnterprisePicture from '@/components/picture-share/components/enterprise-picture.vue'



const instance = new UplusApi()
instance.initDeviceReady()

const shareWayMap = {
  WechatSession: {
    img: 'https://statics02.ehaier.com/h5/ehaier/common/wx_icon.png',
    label: '微信',
    params: { platformType: 'WechatSession' }
  },
  WechatTimeLine: {
    img: 'https://statics02.ehaier.com/h5/ehaier/common/wxtmline_icon.png',
    label: '朋友圈',
    params: { platformType: 'WechatTimeLine' }
  },
  Sina: {
    img: 'https://statics02.ehaier.com/h5/ehaier/common/weibo_icon.png',
    label: '微博',
    params: { platformType: 'Sina' }
  },
  QQ: {
    img: 'https://statics02.ehaier.com/h5/ehaier/common/qq_icon.png',
    label: 'QQ',
    params: { platformType: 'QQ' }
  },
  QQzone: {
    img: 'https://statics02.ehaier.com/h5/ehaier/common/qqzone_icon.png',
    label: 'QQ空间',
    params: { platformType: 'QQzone' }
  },
}

const pageShareType = (type) => {
  switch (type) {
    case 7:
      return ['WechatSession', 'WechatTimeLine']
    case 6:
      return ['WechatSession']
    case 5:
      return ['WechatSession', 'WechatTimeLine']
    case 4:
      return ['WechatSession']
    case 3:
      return ['WechatSession', 'WechatTimeLine']
    case 2:
      return ['WechatSession', 'WechatTimeLine', 'QQ', 'QQzone']
    case 1:
      return ['WechatSession', 'WechatTimeLine', 'QQ', 'QQzone']
    case 0:
      return ['WechatSession', 'WechatTimeLine', 'QQ', 'QQzone']
    case -1:
      return ['WechatSession', 'WechatTimeLine']
    case -2:
      return ['WechatSession', 'WechatTimeLine', 'QQ', 'QQzone']
    case -3:
      return ['WechatSession', 'WechatTimeLine']
    case -4:
      return ['WechatSession']
    default:
      return ['WechatSession', 'WechatTimeLine', 'QQ', 'QQzone', 'Sina']
  }
}

// 根据路由区分不同页面需要不同的分享途径  shopDetail=店铺主页  detail=单品页 detail2b=单品页  unconfirmList合伙人页
const pageFunctions = {
  'enterprisePromo': {
    ways: pageShareType(3),
    params: ''
  },
  renewedArea: {
    ways: pageShareType(7),
    params: ''
  },
  shopDetail: {
    // ways: ['WechatSession', 'WechatTimeLine', 'QQ', 'QQzone', 'CopyLink'],
    ways: pageShareType(1),
    params: 'storeId'
  },
  detail: {
    // ways: ['WechatSession', 'WechatTimeLine', 'QQ', 'QQzone', 'CopyLink', 'Picture'],
    ways: pageShareType(0),
    params: 'productId'
  },
  shopSuitDetail: {
    // ways: ['WechatSession', 'WechatTimeLine', 'QQ', 'QQzone', 'CopyLink'],
    ways: utils.isShopKeeper() ? pageShareType(3) : pageShareType(1),
    params: ''
  },
  shopSuitList: {
    ways: utils.isShopKeeper() ? pageShareType(3) : pageShareType(1),
    params: ''
  },
  dailyTaskDetail: {
    ways: utils.isShopKeeper() ? pageShareType(5) : pageShareType(2),
    params: 'taskId'
  },
  unconfirmList: {
    ways: ['WechatSession'],
    params: 'url'
  },
  vipInvite: {
    ways: ['WechatSession', 'WechatTimeLine'],
    params: ''
  },
  agentPay: {
    ways: ['WechatSession'],
    params: '',
  }
}

// ihaier内分享仅支持【微信，朋友圈】，对pageFunctions进行重置
if (utils.isIhaierApp()) {
  pageFunctions['shopDetail']['ways'] = pageShareType(5)
  pageFunctions['detail']['ways'] = pageShareType(5)
  pageFunctions['detail2b']['ways'] = pageShareType(5)
}

export default {
  components: {
    newGoodMainPicture,
    newShopMainPicture,
    RenewedPicture,
    EnterprisePicture,
  },
  props: {
    show: Boolean,
    wechatTimeLine: {
      type: Number,
      default: 0 // 朋友圈分享类型 0：无默认  1.商品图片 2.店铺图片 3.以旧换新海报
    },
    isExclusive: {
      type: Boolean,
      default: false
    }, // 是否是专属价页面
    canSetPrice: {
      type: Boolean,
      default: false,
    }, // 是否可以设置专属价
    copyCustomLink: {
      type: Boolean,
      default: false
    },
    title: {
      default: undefined,
      type: String,
    },
  },
  data () {
    return {
      shareWayList: []
    }
  },
  created () {
    this.setShopKeeperShareItems()
    // pageFunctions.detail.ways = ['WechatSession', 'WechatTimeLine', 'QQ', 'QQzone', 'Sina', 'CopyLink', 'Picture', 'SetPrice']
    // this.getShareWay()
  },
  mounted () {},
  beforeDestroy () {},
  methods: {
    /**
     * 朋友圈画报分享生成成功
     */
    sharePicFinish(){
    },
    close(){
      this.$emit('update:show', false)
    },
    setShopKeeperShareItems() {
      console.log('watch change', this.canSetPrice, this.isExclusive)
      if (this.canSetPrice) { // 新移动工作台
        pageFunctions[this.$route.name].ways = utils.isShopKeeper() ? pageShareType(-1) : pageShareType(0)
      } else if (this.isExclusive) {
        pageFunctions[this.$route.name].ways = pageShareType(-4)
      }
      this.getShareWay() // 监听数据变化，重新更新分享项
    },
    linkShare() {
      let url = window.location.href 
      const clipboard = new ClipboardJS('.J_copy', {
        text: function (trigger) {
          return url
        }
      });
      clipboard.on('success', () => {
        this.$toast('复制链接成功');
      })
      clipboard.on('error', () => {
        this.$toast('复制链接失败');
      })
    },
    
    shareHandler (params) {
      if (params.callback) {
        this[params.callback]()
      } else {
        this.$emit('customShare', { platformType: params.platformType })
        // if (this.$route.name === 'detail') {
        //   this.$emit('customShare', { platformType: params.platformType })
        // }
        // if (this.$route.name === 'shopDetail') {
        //   this.$emit('customShare', { platformType: params.platformType })
        // }
      }
    },
    getShareWay () {
      if (pageFunctions[this.$route.name]) {
        if (utils.isHaierApp() && !utils.isShopKeeper() && !pageFunctions[this.$route.name].ways.includes('Sina') && !['renewedArea','enterprisePromo'].includes(this.$route.name)) {
          pageFunctions[this.$route.name].ways.push('Sina')
        }

        this.shareWayList = pageFunctions[this.$route.name].ways.map((way) => {
          return shareWayMap[way]
        })
        // ihaier内不展示画报分享
        // if (this.$route.name === 'shopDetail' && !utils.isIhaierApp()) {
        //   this.getShareAuth()
        // }
      }
    },
    
    cancel(){
      this.$emit('cancel')
      this.$emit('update:show', false)
    }
  },
}
</script>
<style lang="scss" scoped>
.custom-share {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.pop-bg{
  background: #f5f5f5;
  border-radius: .32rem;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  box-sizing: border-box;
}
.new-pic-preview{
  margin-bottom: .64rem;
}

.share-wrapper{
  background: transparent;
}
.share-list{
  .share-way-list{
    display: flex;
    padding: 0;
    flex-wrap: nowrap;
    overflow-x: auto;
    box-sizing: border-box;
    padding-right: .32rem;
    li{
      margin-bottom: .48rem !important;
      margin-right: .64rem !important;
      &:first-child{
        margin-left: .32rem;
      }
      .icon-wrapper{
        margin-bottom: .16rem !important;
      }
      .share-name{
        font-size: .24rem !important;
        color: #111 !important;
      }
    }
  }
}

::-webkit-scrollbar{
  display: none;
}

.cancle-btn{
  padding: .16rem .32rem;
  a{
    display: flex;
    justify-content: center;
    align-items: center;
    height: .88rem;
    font-family: "PingFang SC";
    font-size: .32rem;
    font-style: normal;
    font-weight: 500;
    color: #111;
    background: #fff;
    border-radius: .16rem;
  }
}

@supports (bottom: env(safe-area-inset-bottom)){
  .cancle-btn{
    padding-bottom: calc(env(safe-area-inset-bottom) + .16rem);
  }
}

</style>